import styled from "styled-components";

interface PartnerProps {
  partner: {
    name: string;
    thumb: string;
  };
}

export function Partner({ partner }: PartnerProps) {
  return (
    <Content>
      <Image src={partner.thumb} alt={partner.name} />
    </Content>
  );
}

const Content = styled.li`
  margin: 0 4px;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    padding: 0;
    margin-left: 4px;

    &:first-child {
      margin-left: 14px;
    }

    &:last-child {
      margin-right: 14px;
    }
  }
`;

const Image = styled.img`
  display: block;
  border-radius: 5px;
  border: ${({ theme }) => `3px solid ${theme.colors.gray.light}`};

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    width: 180px;
    height: auto;
  }
`;